// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1xJIQ","buttons":"SendReceipts_buttons__5hCMm","email":"SendReceipts_email__1oB2Y","bookApptTitle":"SendReceipts_bookApptTitle__1iVl4"};